export const formatEngagement = (value: number): string => {
  if (value >= 1_000_000) {
    const formatted = (value / 1_000_000).toFixed(1);
    return formatted.endsWith('.0')
      ? `${formatted.slice(0, -2)}M`
      : `${formatted}M`;
  }

  if (value >= 1_000) {
    const formatted = (value / 1_000).toFixed(1);
    const roundedValue = Number(formatted);
    // K 단위 반올림 결과가 1000이면 1M으로 승격
    if (roundedValue >= 1000) {
      return '1M';
    }
    return formatted.endsWith('.0')
      ? `${formatted.slice(0, -2)}K`
      : `${formatted}K`;
  }

  return String(value);
};
